export default [{
    id: 'facebook/react',
    description: 'A declarative, efficient, and flexible JavaScript library for building user interfaces.',
    packagesIds: ['facebook/react'],
    title: 'React',
    avatar: 'https://avatars3.githubusercontent.com/u/69631?v=4',
}, {
    id: 'tensorflow/tensorflow',
    description: 'Computation using data flow graphs for scalable machine learning.',
    packagesIds: ['tensorflow/tensorflow'],
    title: 'Tensor Flow',
    avatar: 'https://avatars1.githubusercontent.com/u/15658638?v=4',
}, {
    id: '3',
    description: 'The Linux kernel is an open-source monolithic Unix-like computer operating system kernel.',
    packagesIds: ['torvalds/linux'],
    title: 'Linux',
    avatar: 'https://avatars0.githubusercontent.com/u/1024025?v=4',
}, {
    id: '4',
    description: 'Go is an open source programming language for building simple and efficient software.',
    packagesIds: ['golang/go'],
    title: 'Go',
    avatar: 'https://avatars3.githubusercontent.com/u/4314092?v=4',
}, {
    id: '5',
    description: 'Bitcoin is an experimental digital currency that enables decentralized payments.',
    packagesIds: ['bitcoin/bitcoin'],
    title: 'Bitcoin',
    avatar: 'https://avatars2.githubusercontent.com/u/528860?v=4',
}, {
    id: '6',
    description: 'Node.js is a JavaScript runtime built on Chrome\'s V8 JavaScript engine.',
    packagesIds: ['nodejs/node'],
    title: 'Node.js',
    avatar: 'https://avatars3.githubusercontent.com/u/9950313?v=4',
}];